document.addEventListener('DOMContentLoaded', function() {
  let currentlyVisibleTag = null;
  let currentlyVisiblePulse = null;

  const pulses = document.querySelectorAll('.product-indicator');
  const section = document.querySelector('.banner-scene-section');

  pulses.forEach(pulse => {
    pulse.addEventListener('click', function(event) {
      event.stopPropagation();
      const parent = pulse.parentElement;
      const productTag = parent.querySelector('.product_tag');

      if (currentlyVisibleTag === productTag) {
        currentlyVisibleTag.style.display = 'none';
        currentlyVisiblePulse.style.opacity = '1';
        currentlyVisibleTag = null;
        currentlyVisiblePulse = null;
      } else {
        if (currentlyVisibleTag) {
          currentlyVisibleTag.style.display = 'none';
          currentlyVisiblePulse.style.opacity = '1';
        }
        productTag.style.display = 'block';
        pulse.style.opacity = '0';
        currentlyVisibleTag = productTag;
        currentlyVisiblePulse = pulse;
      }
    });
  });
  if(section){
    section.addEventListener('click', function() {
      if (currentlyVisibleTag) {
        currentlyVisibleTag.style.display = 'none';
        currentlyVisiblePulse.style.opacity = '1';
        currentlyVisibleTag = null;
        currentlyVisiblePulse = null;
      }
    });
  }
});
